const slicer = state => state.data.shoppingList;

export const selectSelectedListId = state => slicer(state).selectedList;
export const selectArtNbrError = state => slicer(state).artNbrError;
export const selectLists = state => slicer(state).lists ?? {};
export const selectSelectedList = state => selectLists(state)?.[selectSelectedListId(state)];
export const selectSelectedListName = state => selectSelectedList(state)?.name;
export const selectShoppingListView = state => slicer(state).shoppingListView ?? '';
export const selectNewList = state => slicer(state).newList;
export const selectNewListError = state => selectNewList(state)?.error;
